import {
  updateNotifTypes,
  getNotifTypes,
  getInvoicesTypes,
  getAssociatedInvoicesTypes,
  getUnassociatedInvoices,
  getRequestedInvoicesTypes,
  getAccountInvoicesTypes,
  electronicInvoicesTypes,
  sortInvoicesTypes,
  updateAllNotifTypes,
  getReceiptDocumentTypes,
  deleteInvoicesTypes
} from './types';

const invoiceActions = {
  getNotifications: (payload: string) => ({
    type: getNotifTypes.REQUEST,
    payload
  }),
  getNotificationsSuccess: (payload: any) => ({
    type: getNotifTypes.SUCCESS,
    payload
  }),
  updateNotification: (payload: string) => ({
    type: updateNotifTypes.REQUEST,
    payload
  }),
  getInvoicesRequest: (payload: string) => ({
    type: getInvoicesTypes.REQUEST,
    payload
  }),
  updateAllNotification: (payload: string) => ({
    type: updateAllNotifTypes.REQUEST,
    payload
  }),
  updateAllNotificationSuccess: (payload: any) => ({
    type: updateAllNotifTypes.SUCCESS,
    payload
  }),
  getInvoicesSuccess: (payload: any) => ({
    type: getInvoicesTypes.SUCCESS,
    payload
  }),
  getInvoicesFailed: payload => ({
    type: getInvoicesTypes.FAILED,
    payload
  }),

  getAccountInvoicesRequest: (payload: string) => ({
    type: getAccountInvoicesTypes.REQUEST,
    payload
  }),
  getAccountInvoicesSuccess: (payload: any) => ({
    type: getAccountInvoicesTypes.SUCCESS,
    payload
  }),
  getAccountInvoicesFailed: payload => ({
    type: getAccountInvoicesTypes.FAILED,
    payload
  }),

  getAssociatedInvoicesRequest: (payload: string) => ({
    type: getAssociatedInvoicesTypes.REQUEST,
    payload
  }),
  getAssociatedInvoicesSuccess: (payload: any) => ({
    type: getAssociatedInvoicesTypes.SUCCESS,
    payload
  }),
  getAssociatedInvoicesFailed: payload => ({
    type: getAssociatedInvoicesTypes.FAILED,
    payload
  }),

  getUnassociatedInvoices: (payload: string) => ({
    type: getUnassociatedInvoices.REQUEST,
    payload
  }),
  getUnassociatedInvoicesSuccess: (payload: any) => ({
    type: getUnassociatedInvoices.SUCCESS,
    payload
  }),
  getUnassociatedInvoicesFailed: payload => ({
    type: getUnassociatedInvoices.FAILED,
    payload
  }),

  getRequestedInvoicesRequest: (payload: string) => ({
    type: getRequestedInvoicesTypes.REQUEST,
    payload
  }),
  getRequestedInvoicesSuccess: (payload: any) => ({
    type: getRequestedInvoicesTypes.SUCCESS,
    payload
  }),
  getRequestedInvoicesFailed: payload => ({
    type: getRequestedInvoicesTypes.FAILED,
    payload
  }),

  deleteElectronicInvoicesRequest: payload => ({
    type: electronicInvoicesTypes.DELETE_E_REQUEST,
    payload
  }),

  sortRequestedInvoices: payload => ({
    type: sortInvoicesTypes.SORT_REQUESTED,
    payload
  }),
  sortAssociatedInvoices: payload => ({
    type: sortInvoicesTypes.SORT_ASSOCIATED,
    payload
  }),
  sortAccountInvoices: payload => ({
    type: sortInvoicesTypes.SORT_ACCOUNT,
    payload
  }),

  getReceiptDocumentRequest: payload => ({
    type: getReceiptDocumentTypes.REQUEST,
    payload
  }),
  getReceiptDocumentFinish: () => ({
    type: getReceiptDocumentTypes.FINISH
  }),

  deleteInvoicesRequest: payload => ({
    type: deleteInvoicesTypes.DELETE_REQUEST,
    payload
  }),
  deleteInvoicesSuccess: payload => ({
    type: deleteInvoicesTypes.DELETE_SUCCESS,
    payload
  }),
  deleteInvoicesFailed: payload => ({
    type: deleteInvoicesTypes.DELETE_FAILED,
    payload
  }),
};

export default invoiceActions;
